import React from 'react';
import {Route, Redirect, withRouter} from 'react-router-dom';
import {connect} from "react-redux";

import Logo from 'components/common/app/logo';
import {Register, Verify} from 'pages/register';

class RegisterContainer extends React.Component {

    render() {
        let {match, locale} = this.props;

        const renderStyle = () => {
            return (
                <link rel="stylesheet" type="text/css"
                      href={locale && locale.rtl ? './assets/styles/rtl.css' : './assets/styles/ltr.css'}/>
            )
        };

        return (
            <div className="page-content register-container">
                {renderStyle()}
                <div className="register-page-title" style={{marginTop: '8%'}}>
                    <Logo height={110}/>
                </div>

                <Redirect exact from={`${match.url}`} to={`${match.url}/register`}/>
                <Route path={`${match.url}/register`}>
                    <Register/>
                </Route>
                <Route path={`${match.url}/verify`}>
                    <Verify/>
                </Route>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(withRouter(RegisterContainer));
